import { render, staticRenderFns } from "./InputTextMultiSyntax.vue?vue&type=template&id=5a1573ed&scoped=true"
import script from "./InputTextMultiSyntax.vue?vue&type=script&lang=js"
export * from "./InputTextMultiSyntax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1573ed",
  null
  
)

export default component.exports